import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MainApp } from './components/MainApp';
import { useAtom } from 'jotai';
import { darkModeAtom } from './lib/theme';

export default function App() {
  const [isDark] = useAtom(darkModeAtom);

  return (
    <div className={isDark ? 'dark' : ''}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<MainApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}